import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { perseusLocationRepositoryBuilder } from './PerseusLocationRepository'

export const perseusLocationRepository = () => {
  return perseusLocationRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
